<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="1" lg="1"> </v-col>
      <v-col cols="12" sm="12" md="7" lg="7">
        <v-toolbar flat>
          <v-avatar
            v-if="topicObj.status == 'Finished'"
            size="30px"
            icon
            style="margin-right: 2px"
          >
            <v-icon size="35px" dark :color="progressColor"
              >mdi-checkbox-marked-circle</v-icon
            >
          </v-avatar>
          <span v-else>
            <v-avatar
              v-if="topicObj.index >= 0"
              size="30px"
              icon
              dark
              :color="progressColor"
              style="margin-right: 2px"
            >
              <span style="color: white"
                ><strong>{{ topicObj.index + 1 }}</strong></span
              >
            </v-avatar>
            <v-avatar v-else size="30px" icon style="margin-right: 2px">
              <v-icon size="35px" dark :color="progressColor"
                >mdi-alpha-m-circle</v-icon
              >
            </v-avatar>
          </span>
          <div v-if="!isMobile" class="timeChipLabel">
            <div class="timeText">{{ startTime }}</div>
          </div>
          <v-progress-linear
            :value="topicObj.timerValue"
            :color="progressColor"
            :background-color="progressBackgroundColor"
            height="50"
            rounded
            style="border: 1px solid var(--v-appBar-darken1)"
          >
            <strong style="padding-left: 10px">{{ topicObj.topicText }}</strong>
            <v-spacer></v-spacer>
            <strong style="padding-right: 30px"
              >{{ Math.round(topicObj.timerValue) }}%</strong
            >
          </v-progress-linear>
          <div v-if="!isMobile" class="timeChipLabelRright">
            <div class="timeText">{{ endTime }}</div>
          </div>
        </v-toolbar>
      </v-col>
      <v-col cols="12" sm="8" md="2" lg="2" align="left">
        <div class="timeCharts">
          <v-avatar icon size="50" color="secondary darken-3"
            ><strong style="color: white">{{
              topicObj.actualtime
            }}</strong></v-avatar
          >
          <span style="padding-left: 5px">
            <v-progress-circular
              :rotate="360"
              :size="50"
              :width="7"
              :value="Math.ceil((topicObj.elapsed / topicObj.actualtime) * 100)"
              :color="progressColor"
            >
              <strong>{{ Math.floor(topicObj.timeCounter / 60) }}</strong>
            </v-progress-circular>
          </span>
          <span>
            <v-progress-circular
              :rotate="-90"
              :size="50"
              :width="7"
              :value="timerValue"
              :color="progressColor"
              ><strong>{{
                topicObj.timeCounter % 60
              }}</strong></v-progress-circular
            >
          </span>

          <span style="padding-left: 5px" v-if="false">
            <v-progress-circular
              v-if="false"
              :rotate="360"
              :size="50"
              :width="7"
              :value="
                Math.round((topicObj.remaining / topicObj.actualtime) * 100)
              "
              :color="progressColor"
            >
              <strong>{{ topicObj.remaining }}</strong>
            </v-progress-circular>
          </span>
        </div>
      </v-col>
      <v-col cols="12" sm="4" md="2" lg="2" align="left" justify="center">
        <div class="timeControls">
          <span style="padding-left: 5px">
            <span v-if="topicObj.isMeetingTimer && updateMeetingPermission">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    v-on="on"
                    v-bind="attrs"
                    min-width="48px"
                    width="48px"
                    @click.stop="changeMeetingStatus()"
                    color="primaryDark"
                  >
                    <v-icon v-if="isMeetingStarted" dark>mdi-stop</v-icon>
                    <v-icon v-else dark>mdi-play</v-icon>
                  </a-btn>
                </template>
                <span v-if="isMeetingStarted">{{
                  $t("agenda.tipEndMeeting")
                }}</span>
                <span v-else>{{ $t("agenda.tipStartMeeting") }}</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!isMeetingStarted">
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    v-on="on"
                    v-bind="attrs"
                    min-width="48px"
                    width="48px"
                    @click.stop="resetMeetingStatus()"
                    color="primaryDark"
                    class="ml-2"
                  >
                    <v-icon dark>mdi-restart</v-icon>
                  </a-btn>
                </template>
                <span>{{ $t("agenda.tipReset") }}</span>
              </v-tooltip>
            </span>
            <span
              v-else-if="
                topicObj.status == 'Finished' || topicObj.status == 'Started'
              "
            ></span>
            <span v-else-if="!topicObj.isMeetingTimer">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    min-width="48px"
                    width="48px"
                    v-on="on"
                    v-bind="attrs"
                    :color="
                      topicObj.status == 'Started'
                        ? 'warning darken-3'
                        : 'primaryDark'
                    "
                    :disabled="
                      topicObj.status == 'Started' ||
                      !isMeetingStarted ||
                      topicObj.status == 'Skipped'
                    "
                    @click.stop="topicStartStop()"
                  >
                    <v-icon v-if="topicObj.status == 'Started'"
                      >mdi-stop</v-icon
                    >
                    <v-icon v-else>mdi-play</v-icon>
                  </a-btn>
                </template>
                <span v-if="topicObj.status == 'Started'">
                  {{ $t("End") }}
                </span>
                <span v-else> {{ $t("Start") }} </span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    v-if="updateMeetingPermission"
                    v-on="on"
                    v-bind="attrs"
                    min-width="48px"
                    width="48px"
                    color="primaryDark"
                    class="ml-2"
                    :disabled="
                      topicObj.status == 'Started' ||
                      topicObj.status == 'Finished'
                    "
                    @click.stop="topicSkippUnskipp()"
                  >
                    <v-icon v-if="topicObj.status === 'Skipped'"
                      >mdi-playlist-plus</v-icon
                    >
                    <v-icon v-else>mdi-playlist-minus</v-icon>
                  </a-btn>
                </template>
                <span v-if="topicObj.status === 'Skipped'">{{
                  $t("Unskip")
                }}</span>
                <span v-else>{{ $t("Skip") }}</span>
              </v-tooltip>
            </span>
          </span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "MeetingTimer",
  data() {
    return {
      meetingTimerValue: 0,
      toggle_none: null,

      topicObj: {
        starttime: "",
        endtime: "",
        actualtime: "",
        elapsed: "",
        remaining: "",
        status: "Skipped", //  Skipped,Started, Finished
        lessTimeWarning: false,
        timerValue: "",
        topicText: "Test Topic",
        isMeetingTimer: false,
        timeCounter: 0,
      },
    };
  },
  props: {
    topicObject: Object,
    isMeetingStarted: Boolean,
    previousTimerObj: Object,
  },
  created() {
    this.topicObj = Object.assign({}, this.topicObject);
  },
  watch: {
    toggle_none(val) {
      if (val == 0) {
        this.topicObj.status = "Started";
        this.topicObj.starttime = new Date().toISOString();
      }
      if (val == 1) {
        this.topicObj.status = "Skipped";
      }
      this.$emit("onTopicTimerStatusChanged", this.topicObj);
    },
  },
  mounted: function () {
    this.$nextTick(function () {
      window.setInterval(() => {
        this.calculateTimers();
      }, 1000);
    });

    this.$root.$on("refresh-timer", (obj) => {
      this.refreshTimer(obj);
    });
  },
  beforeDestroy() {
    this.$root.$off("refresh-timer");
  },
  computed: {
    ...mapGetters({ getMeetingTypeId: "meeting/getMeetingTypeId" }),
    timerValue() {
      return ((this.topicObj.timeCounter % 60) / 60) * 100;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    startTime() {
      if (this.topicObj.startMeetingTime) {
        return this.topicObj.startMeetingTime == "-"
          ? this.topicObj.startMeetingTime
          : new Date(this.topicObj.startMeetingTime).toLocaleTimeString();
      } else {
        return this.topicObj.starttime == "-"
          ? this.topicObj.starttime
          : new Date(this.topicObj.starttime).toLocaleTimeString();
      }
    },
    endTime() {
      if (this.topicObj.endMeetingTime) {
        return this.topicObj.endMeetingTime == "-"
          ? this.topicObj.endMeetingTime
          : new Date(this.topicObj.endMeetingTime).toLocaleTimeString();
      } else {
        return this.topicObj.endtime == "-"
          ? this.topicObj.endtime
          : new Date(this.topicObj.endtime).toLocaleTimeString();
      }
    },
    // endTime() {
    //   return this.topicObj.endtime == "-"
    //     ? this.topicObj.endtime
    //     : new Date(this.topicObj.endtime).toLocaleTimeString();
    // },
    progressColor() {
      return this.getProgressBackgroundColor();
    },

    progressBackgroundColor() {
      return this.progressColor + " lighten-4";
    },
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
  },
  methods: {
    refreshTimer(obj) {
      this.topicObj.status = obj.status;
      this.topicObj.timerValue = 0;
      this.topicObj.timeCounter = 0;
      this.topicObj.elapsed = obj.elapsed;
      this.topicObj.starttime = obj.starttime;
      this.topicObj.endtime = obj.endtime;
      this.topicObj.startMeetingTime = obj.startMeetingTime;
      this.topicObj.endMeetingTime = obj.endMeetingTime;
    },
    topicStartStop() {
      this.topicObj.status = "Started";
      this.topicObj.starttime = new Date().toISOString();
      this.$emit("onTopicTimerStatusChanged", this.topicObj);
      this.$emit("startStop", this.topicObj);
    },
    topicSkippUnskipp() {
      if (this.topicObj.status === "Skipped") {
        this.topicObj.status = "NotStarted";
      } else {
        this.topicObj.status = "Skipped";
      }
      this.$emit("onChangeTopicStatus", this.topicObj);
    },
    changeMeetingStatus() {
      if (this.isMeetingStarted) {
        this.topicObj.endMeetingTime = new Date().toISOString();
      } else {
        this.topicObj.startMeetingTime = this.topicObj.startMeetingTime
          ? this.topicObj.startMeetingTime
          : new Date().toISOString();
      }
      this.$emit("getMeetingTimerData", this.topicObj, !this.isMeetingStarted);
      this.$emit("startStop", this.topicObj, this.isMeetingStarted);
    },

    resetMeetingStatus() {
      this.$emit("resetMeetingTimer");
    },
    calculateTimers() {
      // this.topicObj = Object.assign({}, this.topicObject);
      let now = new Date();
      if (!this.isMeetingStarted) {
        this.stopPreviousTimer();
        return;
      }
      if (
        this.topicObj.isMeetingTimer
        //&& new Date(this.topicObj.starttime) > now //test
      ) {
        let elapsed = this.topicObj.timeCounter / 60;
        this.topicObj.status = "Started";
        this.topicObj.timeCounter++;
        this.topicObj.elapsed = elapsed;
        if (this.topicObj.actualtime == 0) {
          this.topicObj.timerValue = 100 + elapsed * 100;
          this.topicObj.remaining = Math.round(
            this.topicObj.actualtime - this.topicObj.elapsed
          );
          this.$emit(
            "getMeetingTimerData",
            this.topicObj,
            this.isMeetingStarted
          );
          return;
        }
        this.topicObj.remaining = Math.round(
          this.topicObj.actualtime - this.topicObj.elapsed
        );

        this.topicObj.timerValue = (elapsed / this.topicObj.actualtime) * 100;
        this.$emit("getMeetingTimerData", this.topicObj, this.isMeetingStarted);
      } else if (!this.topicObj.isMeetingTimer && this.isMeetingStarted) {
        if (this.topicObj.status === "Started") {
          //stop previous Timer
          this.stopPreviousTimer();
          let elapsed = this.topicObj.timeCounter / 60;
          this.topicObj.timeCounter++;
          this.topicObj.elapsed = elapsed;
          if (this.topicObj.actualtime == 0) {
            this.topicObj.timerValue = 100 + elapsed * 100;
            this.topicObj.remaining = Math.round(
              this.topicObj.actualtime - this.topicObj.elapsed
            );
            this.$emit("onSyncTopicTimerData", this.topicObj, true);
            return;
          }
          this.topicObj.remaining = Math.round(
            this.topicObj.actualtime - this.topicObj.elapsed
          );
          this.topicObj.timerValue = (elapsed / this.topicObj.actualtime) * 100;
        }

        this.$emit("onSyncTopicTimerData", this.topicObj, true);
      }
    },

    stopPreviousTimer() {
      if (this.previousTimerObj) {
        if (this.topicObj.index === this.previousTimerObj.index) {
          this.topicObj.status = this.previousTimerObj.status;
          this.topicObj.endtime = this.previousTimerObj.endtime;
          return;
        }
      }
    },
    getProgressBackgroundColor() {
      if (this.topicObj.status === null) {
        return "grey";
      }
      if (
        this.topicObj.status === "Finished" ||
        (this.topicObj.isMeetingTimer &&
          !this.isMeetingStarted &&
          this.topicObj.elapsed > 0)
      ) {
        if (this.topicObj.timerValue <= 100) {
          return "primary lighten-2";
        } else {
          return "error lighten-1";
        }
      }
      if (
        this.topicObj.isMeetingTimer &&
        !this.isMeetingStarted &&
        this.topicObj.elapsed == 0
      ) {
        return "grey";
      }
      if (this.topicObj.lessTimeWarning) {
        return "warning darken-2";
      }
      if (this.topicObj.status === "Skipped") {
        return "appBar";
      }
      if (this.topicObj.status === "NotStarted") {
        return "grey";
      }
      if (this.topicObj.timerValue <= 80) {
        return "success";
      } else if (
        this.topicObj.timerValue > 80 &&
        this.topicObj.timerValue <= 90
      ) {
        return "warning";
      } else if (
        this.topicObj.timerValue > 90 &&
        this.topicObj.timerValue <= 100
      ) {
        return "orange";
      } else {
        return "error";
      }
    },
  },
};
</script>
<style scoped>
::v-deep .timeControls {
  padding-top: 12px;
  padding-bottom: 12px;
}

::v-deep .timeCharts {
  width: 157px;
  margin-top: 5px;
  background-color: #f5f5f5;
  border: 1px solid var(--v-appBar-darken1);
  border-top-left-radius: 27px;
  border-bottom-left-radius: 27px;
  border-top-right-radius: 27px;
  border-bottom-right-radius: 27px;
}

::v-deep .timeChipLabel {
  width: 120px;
  height: 50px;
  padding: 0px 5px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  background-color: var(--v-secondary-darken3);
  color: white;
  font-size: small;
  justify-content: center;
  display: flex;
}

::v-deep .timeChipLabelRright {
  width: 120px;
  height: 50px;
  padding: 0px 5px;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  background-color: var(--v-secondary-darken3);
  color: white;
  font-size: small;
  display: flex;
  justify-content: center;
}

::v-deep .timeText {
  margin-top: 13px;
}

::v-deep .v-sheet.v-toolbar:not(.v-sheet--outlined) {
  height: 25px !important;
}
</style>